import { useCallback } from 'react';

import { useMediaLibraryPicker } from '../../../hooks/useMediaLibraryPicker';
import type { AssetLibraryMediaSelection } from '../../AssetLibrary/assetLibraryMediaSelection';
import type { BatchMascotUploadStore } from '../batchMascotUploadStore';
import type { MascotRow } from '../types';

export function useMascotRowLibraryPickers(
  row: MascotRow,
  store: BatchMascotUploadStore,
) {
  const getMotionInitialSelection = useCallback(
    () => (row.libraryMotionRef ? [row.libraryMotionRef] : []),
    [row.libraryMotionRef],
  );

  const getCharacterInitialSelection = useCallback(
    () => row.libraryCharRefs,
    [row.libraryCharRefs],
  );

  const getBackgroundInitialSelection = useCallback(
    () => (row.libraryBackgroundRef ? [row.libraryBackgroundRef] : []),
    [row.libraryBackgroundRef],
  );

  const motionPicker = useMediaLibraryPicker({
    mediaKind: 'video',
    mode: 'single',
    getInitialSelection: getMotionInitialSelection,
    onConfirm: (selections: AssetLibraryMediaSelection[]) => {
      store.setRowLibraryMotionRef(row.id, selections[0] ?? null);
    },
  });

  const characterPicker = useMediaLibraryPicker({
    mediaKind: 'image',
    mode: 'multi',
    getInitialSelection: getCharacterInitialSelection,
    onConfirm: (selections: AssetLibraryMediaSelection[]) => {
      store.setRowLibraryCharRefs(row.id, selections);
    },
  });

  const backgroundPicker = useMediaLibraryPicker({
    mediaKind: 'image',
    mode: 'single',
    getInitialSelection: getBackgroundInitialSelection,
    onConfirm: (selections: AssetLibraryMediaSelection[]) => {
      store.setRowLibraryBackgroundRef(row.id, selections[0] ?? null);
    },
  });

  return {
    motionPicker,
    characterPicker,
    backgroundPicker,
  };
}
